// import React, { useState, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { useSelector } from "react-redux";
// import { RiDeleteBin5Line } from "react-icons/ri";
// import { IoMdMore } from "react-icons/io";
// import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
// import { FaCloudArrowUp } from "react-icons/fa6";
// import { InputLabel, MenuItem, FormControl, Select } from "@mui/material";
// import styles from "../CommonStyles/commonstylesDetails.module.scss";
// import uploadAnimation from "../../../../assets/gif/uploadAnimation.gif";
// import DeleteBox from "../../../../components/DeleteBox/DeleteBox";
// import useMultipleFileUploadAws from "../../../../hooks/AWSFileUpload/useMultipleFileUploadAws";
// import {
//   useFetchAllServices,
//   useCreateService,
//   useRemoveService,
// } from "../../../../hooks/partnerHook/usePartnerService";
// import { useFetchCategory } from "../../../../hooks/partnerHook/usePartnerService";

// const ServiceDetails = () => {
//   const { serviceId } = useParams();
//   const navigate = useNavigate();
//   const userData = useSelector((state) => state.partner.user);
//   const partnerId = userData?.partner?.id;
//   const { data: services, isPending, isError } = useFetchAllServices(partnerId);
//   const {
//     data: categoryData,
//     isError: categoryError,
//     error: categoryErrorDetails,
//   } = useFetchCategory();
//   const serviceCategories = categoryData || [];
//   const { mutate: updateService, isPending: serviceUpdatePending } =
//     useCreateService(navigate); // Reusing useCreateService for updates
//   const {
//     mutate: deleteService,
//     isSuccess: serviceDeleted,
//     isError: deletionError,
//   } = useRemoveService();
//   const {
//     uploadErrors,
//     uploadFileToS3,
//     cancelUpload,
//     mediaUrls,
//     uploadProgresses,
//     estimatedTimes,
//   } = useMultipleFileUploadAws();

//   const service = services?.find(
//     (service) => parseInt(service.service_id) === parseInt(serviceId)
//   );

//   const [isExpanded, setIsExpanded] = useState(false);
//   const [showMenu, setShowMenu] = useState(false);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [isEditing, setIsEditing] = useState(false);
//   const [formData, setFormData] = useState({
//     title: "",
//     description: "",
//     sub_category: "",
//     verification_status: "pending",
//     verification_notes: null,
//     image: null,
//     serviceMediaUrl: "",
//     media_type: "image",
//     price: "",
//     location: "",
//   });
//   const [uploading, setUploading] = useState(false);
//   const [uploadSuccess, setUploadSuccess] = useState(false);
//   const [uploadPreview, setUploadPreview] = useState(uploadAnimation);
//   const [dragging, setDragging] = useState(false);
//   const [errorMessage, setErrorMessage] = useState("");

//   useEffect(() => {
//     if (service) {
//       setFormData({
//         title: service.title || "",
//         description: service.description || "",
//         sub_category: service.sub_category?.id || "",
//         verification_status: service.verification_status || "pending",
//         verification_notes: service.verification_notes || null,
//         image: null,
//         serviceMediaUrl: service.media?.[0]?.media_url || "",
//         media_type: service.media?.[0]?.media_type || "image",
//         price: service.price || "",
//         location: service.location || "",
//       });
//       setUploadPreview(service.media?.[0]?.media_url || uploadAnimation);
//       setUploadSuccess(!!service.media?.[0]?.media_url);
//     }
//   }, [service]);

//   useEffect(() => {
//     if (mediaUrls && formData?.image?.name && mediaUrls[formData.image.name]) {
//       setFormData((prevData) => ({
//         ...prevData,
//         serviceMediaUrl: mediaUrls[formData.image.name],
//         media_type: "image",
//       }));
//       setUploadSuccess(true);
//       setUploading(false);
//       setUploadPreview(mediaUrls[formData.image.name]);
//     }
//   }, [mediaUrls, formData.image?.name]);

//   const handleDelete = () => {
//     if (serviceId && partnerId) {
//       deleteService(
//         { partnerId, serviceId },
//         {
//           onSuccess: () => {
//             navigate("/dashboard/services");
//           },
//         }
//       );
//       setShowDeleteModal(false);
//     } else {
//       setErrorMessage("Failed to delete service. Missing IDs.");
//     }
//   };

//   const handleEdit = () => {
//     setIsEditing(true);
//     setShowMenu(false);
//   };

//   const handleSubmit = async (event) => {
//     event.preventDefault();
//     setErrorMessage("");
//     try {
//       if (!formData.serviceMediaUrl) {
//         setErrorMessage("Please upload an image before submitting.");
//         return;
//       }
//       if (!partnerId) {
//         setErrorMessage("Partner ID is missing.");
//         return;
//       }
//       if (!formData.sub_category) {
//         setErrorMessage("Please select a valid service category.");
//         return;
//       }

//       const { image, ...serviceData } = formData;
//       await updateService(
//         {
//           partnerId,
//           formData: serviceData,
//         },
//         {
//           onSuccess: () => {
//             setIsEditing(false);
//             navigate(`/dashboard/services/${serviceId}`);
//           },
//           onError: (error) => {
//             setErrorMessage(
//               error.response?.data?.message ||
//                 error.message ||
//                 "Failed to update service. Please try again."
//             );
//           },
//         }
//       );
//     } catch (error) {
//       setErrorMessage(
//         error.message || "Failed to update service. Please try again."
//       );
//     }
//   };

//   const handleInputChange = (event) => {
//     const { name, value, files } = event.target;

//     if (name === "image" && files) {
//       const file = files[0];
//       if (file) {
//         const reader = new FileReader();
//         reader.onloadend = () => {
//           const isImage = file.type.startsWith("image/");
//           if (isImage) {
//             setFormData((prevData) => ({
//               ...prevData,
//               image: file,
//               media_type: "image",
//               serviceMediaUrl: "",
//             }));
//             setUploadSuccess(false);
//             setUploadPreview(reader.result);
//             setUploading(false);
//             setErrorMessage("");
//           } else {
//             setErrorMessage("Please upload a valid image file.");
//           }
//         };
//         reader.readAsDataURL(file);
//       }
//     } else {
//       setFormData((prevData) => ({
//         ...prevData,
//         [name]: value,
//       }));
//     }
//   };

//   const handleFileUpload = (file) => {
//     if (!file) return;

//     const validFormats = ["image/png", "image/jpeg"];
//     if (!validFormats.includes(file.type)) {
//       setErrorMessage("Invalid file format. Only PNG & JPG are allowed.");
//       return;
//     }

//     setErrorMessage("");
//     setFormData((prevData) => ({
//       ...prevData,
//       image: file,
//       media_type: "image",
//       serviceMediaUrl: "",
//     }));

//     const reader = new FileReader();
//     reader.onload = () => {
//       setUploadPreview(reader.result);
//     };
//     reader.readAsDataURL(file);
//   };

//   const handleDrop = (event) => {
//     event.preventDefault();
//     setDragging(false);
//     const file = event.dataTransfer.files[0];
//     handleFileUpload(file);
//   };

//   const handleBrowseClick = () => {
//     document.getElementById("file-input").click();
//   };

//   const handleCancel = () => {
//     if (formData.image) {
//       cancelUpload(formData.image.name);
//     }
//     setFormData((prevData) => ({
//       ...prevData,
//       image: null,
//       serviceMediaUrl: "",
//       media_type: "image",
//     }));
//     setUploading(false);
//     setUploadSuccess(false);
//     setUploadPreview(uploadAnimation);
//     setErrorMessage("");
//   };

//   const handleUpload = async () => {
//     if (formData.image) {
//       setUploading(true);
//       try {
//         await uploadFileToS3(formData.image);
//       } catch (error) {
//         setUploading(false);
//         setErrorMessage("Failed to upload the file. Please try again.");
//       }
//     } else {
//       setErrorMessage("No image selected for upload.");
//     }
//   };

//   if (isPending || serviceUpdatePending) {
//     return <h2>Loading Service Details...</h2>;
//   }

//   if (isError) {
//     return <h2>Error: Failed to fetch service data. Please try again.</h2>;
//   }

//   if (!services) {
//     return <h2>Error: No service data found!</h2>;
//   }

//   if (!service) {
//     return <h2>Error: Service not found!</h2>;
//   }

//   return (
//     <div className={styles.detailsContainer}>
//       {!isEditing ? (
//         <>
//           <div className={styles.titleContainer}>
//             <h2 className={styles.equipmentTitle}>{service.title}</h2>
//             <div className={styles.menuContainer}>
//               <IoMdMore
//                 className={styles.moreIcon}
//                 onClick={() => setShowMenu(!showMenu)}
//               />
//               {showMenu && (
//                 <div className={styles.menuDropdown}>
//                   <div className={styles.menuItem} onClick={handleEdit}>
//                     Edit
//                   </div>
//                   <div
//                     className={styles.menuItem}
//                     onClick={() => {
//                       setShowDeleteModal(true);
//                       setShowMenu(false);
//                     }}
//                   >
//                     Delete
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>

//           <div className={styles.infoSection}>
//             <div className={styles.innerInfoSection}>
//               <span
//                 className={`${styles.infoSectionSpan} ${
//                   service.verification_status === "verified"
//                     ? styles.verified
//                     : service.verification_status === "pending"
//                     ? styles.pending
//                     : styles.rejected
//                 }`}
//               >
//                 {service.verification_status === "pending"
//                   ? "Requested to verify"
//                   : service.verification_status === "success"
//                   ? "Verified"
//                   : "Rejected"}
//               </span>

//               <div
//                 className={`${styles.infoSectionDropdownBtn} ${
//                   isExpanded ? styles.expanded : ""
//                 }`}
//                 onClick={() => setIsExpanded(!isExpanded)}
//               >
//                 {isExpanded ? (
//                   <IoIosArrowUp color="white" />
//                 ) : (
//                   <IoIosArrowDown color="white" />
//                 )}
//               </div>
//             </div>

//             <div
//               className={`${styles.infoContent} ${
//                 isExpanded ? styles.showContent : ""
//               }`}
//             >
//               {service.verification_notes == null
//                 ? "Wait for Admin to verify your service."
//                 : service.verification_notes}
//             </div>
//           </div>

//           <div className={styles.imageCard}>
//             <img
//               src={service.media?.[0]?.media_url || "/default-image.jpg"}
//               alt={service.title}
//               className={styles.equipmentImage}
//             />
//             <span
//               className={`${styles.verificationStatus} ${
//                 service.verification_status === "verified"
//                   ? styles.verified
//                   : service.verification_status === "pending"
//                   ? styles.pending
//                   : styles.rejected
//               }`}
//             >
//               {service.verification_status === "pending"
//                 ? "Requested to verify"
//                 : service.verification_status === "success"
//                 ? "Verified"
//                 : "Rejected"}
//             </span>
//           </div>

//           <div className={styles.equipmentDetails}>
//             <Detail label="Description" value={service.description} />
//             <Detail
//               label="Category"
//               value={service.sub_category?.category?.category_name}
//             />
//             <Detail
//               label="Price"
//               value={service.price ? `$${service.price}` : null}
//             />
//             <Detail label="Location" value={service.location} />
//             <Detail
//               label="Created At"
//               value={new Date(service.created_at).toLocaleDateString()}
//             />
//           </div>
//         </>
//       ) : (
//         <div className={styles.formContainer}>
//           <form className={styles.mainFormContainer} onSubmit={handleSubmit}>
//             <h2 className={styles.formHeading}>Edit Service</h2>
//             <p className={styles.formDescription}>
//               Update details about your service and its capabilities.
//             </p>
//             {errorMessage && (
//               <p className={styles.errorMessage}>{errorMessage}</p>
//             )}
//             <div className={styles.formInputContainer}>
//               <h3 className={styles.labels}>Service Name</h3>
//               <input
//                 className={styles.formInput}
//                 name="title"
//                 type="text"
//                 value={formData.title}
//                 placeholder="Enter Service Name"
//                 onChange={handleInputChange}
//                 required
//               />
//               <h3 className={styles.labels}>Service Description</h3>
//               <input
//                 className={styles.formInput}
//                 name="description"
//                 type="text"
//                 value={formData.description}
//                 placeholder="Enter Service Description"
//                 onChange={handleInputChange}
//                 required
//               />
//               <h3 className={styles.labels}>Price</h3>
//               <input
//                 className={styles.formInput}
//                 name="price"
//                 type="number"
//                 value={formData.price}
//                 placeholder="Enter Price"
//                 onChange={handleInputChange}
//               />
//               <h3 className={styles.labels}>Location</h3>
//               <input
//                 className={styles.formInput}
//                 name="location"
//                 type="text"
//                 value={formData.location}
//                 placeholder="Enter Location"
//                 onChange={handleInputChange}
//               />
//               <h3 className={styles.labels}>Upload Image</h3>
//               <div
//                 className={styles.DragUploader}
//                 onDragOver={(e) => e.preventDefault()}
//                 onDrop={handleDrop}
//               >
//                 <div
//                   className={`${styles.DragUploaderImageContainer} ${
//                     dragging ? styles.dragActive : ""
//                   }`}
//                 >
//                   {!formData.image && !formData.serviceMediaUrl ? (
//                     <>
//                       <FaCloudArrowUp className={styles.uploadIcon} />
//                       <p className={styles.uploadText}>Drop images here</p>
//                       <p className={styles.supportedFormats}>
//                         Supported formats: PNG, JPG
//                       </p>
//                       17 <p className={styles.orText}>OR</p>
//                       <h2
//                         className={styles.browseText}
//                         onClick={handleBrowseClick}
//                       >
//                         <strong>Browse Images</strong>
//                       </h2>
//                     </>
//                   ) : (
//                     <img
//                       src={uploadPreview}
//                       alt="Preview"
//                       className={styles.imagePreview}
//                     />
//                   )}

//                   <input
//                     id="file-input"
//                     type="file"
//                     accept="image/png, image/jpeg"
//                     className={styles.fileInput}
//                     onChange={(e) => handleFileUpload(e.target.files[0])}
//                     hidden
//                   />
//                 </div>

//                 <div className={styles.buttonContainer}>
//                   <span
//                     className={styles.cancelText}
//                     onClick={handleCancel}
//                     style={{ display: "grid", placeItems: "center" }}
//                   >
//                     Cancel
//                   </span>
//                   <button
//                     type="button"
//                     className={styles.uploadButton}
//                     onClick={handleUpload}
//                     disabled={uploadSuccess}
//                   >
//                     {uploadSuccess ? "Uploaded" : "Upload"}
//                   </button>
//                 </div>
//               </div>

//               <div className={styles.categorySection}>
//                 <div className={styles.selectContainer}>
//                   <h3 className={styles.labels1}>Choose Category</h3>
//                   <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
//                     <InputLabel id="category-select-label">Category</InputLabel>
//                     <Select
//                       labelId="category-select-label"
//                       id="category-select"
//                       value={formData.sub_category}
//                       label="Category"
//                       onChange={handleInputChange}
//                       name="sub_category"
//                       required
//                     >
//                       <MenuItem value="">
//                         <em>None</em>
//                       </MenuItem>
//                       {serviceCategories.map((category) => (
//                         <MenuItem key={category.id} value={category.id}>
//                           {category.category_name}
//                         </MenuItem>
//                       ))}
//                     </Select>
//                   </FormControl>
//                 </div>
//               </div>
//             </div>

//             <div className={styles.formButtonsContainer}>
//               <button
//                 type="button"
//                 className={styles.cancelButton}
//                 onClick={() => setIsEditing(false)}
//               >
//                 Cancel
//               </button>
//               <button className={styles.saveButton} type="submit">
//                 Save
//               </button>
//             </div>
//           </form>
//         </div>
//       )}

//       {showDeleteModal && (
//         <DeleteBox
//           deleteFunction={handleDelete}
//           isSuccess={serviceDeleted}
//           isError={deletionError}
//           contentName={service.title}
//           setShowDeleteModal={setShowDeleteModal}
//         />
//       )}
//     </div>
//   );
// };

// // Reusable detail item component
// const Detail = ({ label, value }) => (
//   <div className={styles.detailItem}>
//     <strong>{label}:</strong> <span>{value ?? "N/A"}</span>
//   </div>
// );

// export default ServiceDetails;

import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RiDeleteBin5Line } from "react-icons/ri";
import { IoMdMore } from "react-icons/io";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { FaCloudArrowUp } from "react-icons/fa6";
import { InputLabel, MenuItem, FormControl, Select } from "@mui/material";
import styles from "../CommonStyles/commonstylesDetails.module.scss";
import uploadAnimation from "../../../../assets/gif/uploadAnimation.gif";
import DeleteBox from "../../../../components/DeleteBox/DeleteBox";
// import ServicePackageForm from "./ServicePackageForm"; // Import the ServicePackageForm
import useMultipleFileUploadAws from "../../../../hooks/AWSFileUpload/useMultipleFileUploadAws";
import {
  useFetchServiceById, // Use the new hook
  useCreateService,
  useRemoveService,
  useFetchCategory,
} from "../../../../hooks/partnerHook/usePartnerService";

const ServiceDetails = () => {
  const { serviceId } = useParams();
  const navigate = useNavigate();
  const userData = useSelector((state) => state.partner.user);
  const partnerId = userData?.partner?.id;

  const {
    data: service,
    isPending,
    isError,
    error,
  } = useFetchServiceById(partnerId, serviceId);
  const {
    data: categoryData,
    isError: categoryError,
    error: categoryErrorDetails,
  } = useFetchCategory();
  const { mutate: updateService, isPending: serviceUpdatePending } =
    useCreateService(navigate);
  const {
    mutate: deleteService,
    isSuccess: serviceDeleted,
    isError: deletionError,
  } = useRemoveService();
  const {
    uploadErrors,
    uploadFileToS3,
    cancelUpload,
    mediaUrls,
    uploadProgresses,
    estimatedTimes,
  } = useMultipleFileUploadAws();

  const serviceCategories = categoryData || [];

  const [isExpanded, setIsExpanded] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    sub_category: "",
    verification_status: "pending",
    verification_notes: null,
    image: null,
    serviceMediaUrl: "",
    media_type: "image",
    price: "",
    location: "",
    pricing: {
      half: { hours: "", price: "" },
      full: { hours: "", price: "" },
    },
    faqs: [], // Add faqs to match createService structure
    keywords: [], // Add keywords to match createService structure
    gallery: {
      mediaFiles: [], // Add gallery to match createService structure
      youtubeLink: "",
    },
  });
  const [uploading, setUploading] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [uploadPreview, setUploadPreview] = useState(uploadAnimation);
  const [dragging, setDragging] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (service) {
      setFormData({
        title: service.title || "",
        description: service.description || "",
        sub_category: service.sub_category?.id || "",
        verification_status: service.verification_status || "pending",
        verification_notes: service.verification_notes || null,
        image: null,
        serviceMediaUrl: service.media?.[0]?.media_url || "",
        media_type: service.media?.[0]?.media_type || "image",
        price: service.price || "",
        location: service.location || "",
        pricing: {
          half: {
            hours:
              service.packages?.find((p) => p.package_name === "half")?.hours ||
              "",
            price:
              service.packages?.find((p) => p.package_name === "half")?.price ||
              "",
          },
          full: {
            hours:
              service.packages?.find((p) => p.package_name === "full")?.hours ||
              "",
            price:
              service.packages?.find((p) => p.package_name === "full")?.price ||
              "",
          },
        },
        faqs: service.faq || [],
        keywords: service.keywords || [],
        gallery: {
          mediaFiles: service.media || [],
          youtubeLink:
            service.media?.find((m) => m.media_type === "video")?.media_url ||
            "",
        },
      });
      setUploadPreview(service.media?.[0]?.media_url || uploadAnimation);
      setUploadSuccess(!!service.media?.[0]?.media_url);
    }
  }, [service]);

  useEffect(() => {
    if (mediaUrls && formData?.image?.name && mediaUrls[formData.image.name]) {
      setFormData((prevData) => ({
        ...prevData,
        serviceMediaUrl: mediaUrls[formData.image.name],
        media_type: "image",
        gallery: {
          ...prevData.gallery,
          mediaFiles: [
            ...prevData.gallery.mediaFiles,
            { type: "image", url: mediaUrls[formData.image.name] },
          ],
        },
      }));
      setUploadSuccess(true);
      setUploading(false);
      setUploadPreview(mediaUrls[formData.image.name]);
    }
  }, [mediaUrls, formData.image?.name]);

  const handleDelete = () => {
    if (serviceId && partnerId) {
      deleteService(
        { partnerId, serviceId },
        {
          onSuccess: () => {
            navigate("/dashboard/services");
          },
        }
      );
      setShowDeleteModal(false);
    } else {
      setErrorMessage("Failed to delete service. Missing IDs.");
    }
  };

  const handleEdit = () => {
    setIsEditing(true);
    setShowMenu(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage("");
    try {
      if (!formData.serviceMediaUrl && !formData.image) {
        setErrorMessage("Please upload an image before submitting.");
        return;
      }
      if (!partnerId) {
        setErrorMessage("Partner ID is missing.");
        return;
      }
      if (!formData.sub_category) {
        setErrorMessage("Please select a valid service category.");
        return;
      }

      const serviceData = {
        serviceTitle: formData.title,
        description: formData.description,
        subCategory: formData.sub_category,
        packages: [
          {
            package_name: "half",
            hours: formData.pricing.half.hours,
            price: formData.pricing.half.price,
            description: "Half-day package",
          },
          {
            package_name: "full",
            hours: formData.pricing.full.hours,
            price: formData.pricing.full.price,
            description: "Full-day package",
          },
        ],
        faqs: formData.faqs,
        keywords: formData.keywords,
        gallery: formData.gallery,
      };

      await updateService(
        {
          partnerId,
          formData: serviceData,
        },
        {
          onSuccess: () => {
            setIsEditing(false);
            navigate(`/dashboard/services/${serviceId}`);
          },
          onError: (error) => {
            setErrorMessage(
              error.response?.data?.message ||
                error.message ||
                "Failed to update service. Please try again."
            );
          },
        }
      );
    } catch (error) {
      setErrorMessage(
        error.message || "Failed to update service. Please try again."
      );
    }
  };

  const handleInputChange = (event) => {
    const { name, value, files } = event.target;

    if (name === "image" && files) {
      const file = files[0];
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          const isImage = file.type.startsWith("image/");
          if (isImage) {
            setFormData((prevData) => ({
              ...prevData,
              image: file,
              media_type: "image",
              serviceMediaUrl: "",
            }));
            setUploadSuccess(false);
            setUploadPreview(reader.result);
            setUploading(false);
            setErrorMessage("");
          } else {
            setErrorMessage("Please upload a valid image file.");
          }
        };
        reader.readAsDataURL(file);
      }
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleFileUpload = (file) => {
    if (!file) return;

    const validFormats = ["image/png", "image/jpeg"];
    if (!validFormats.includes(file.type)) {
      setErrorMessage("Invalid file format. Only PNG & JPG are allowed.");
      return;
    }

    setErrorMessage("");
    setFormData((prevData) => ({
      ...prevData,
      image: file,
      media_type: "image",
      serviceMediaUrl: "",
    }));

    const reader = new FileReader();
    reader.onload = () => {
      setUploadPreview(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setDragging(false);
    const file = event.dataTransfer.files[0];
    handleFileUpload(file);
  };

  const handleBrowseClick = () => {
    document.getElementById("file-input").click();
  };

  const handleCancel = () => {
    if (formData.image) {
      cancelUpload(formData.image.name);
    }
    setFormData((prevData) => ({
      ...prevData,
      image: null,
      serviceMediaUrl: "",
      media_type: "image",
    }));
    setUploading(false);
    setUploadSuccess(false);
    setUploadPreview(uploadAnimation);
    setErrorMessage("");
  };

  const handleUpload = async () => {
    if (formData.image) {
      setUploading(true);
      try {
        await uploadFileToS3(formData.image);
      } catch (error) {
        setUploading(false);
        setErrorMessage("Failed to upload the file. Please try again.");
      }
    } else {
      setErrorMessage("No image selected for upload.");
    }
  };

  const handleNext = () => {
    // Optional: Add logic to save pricing data if needed before submission
    setIsEditing(false); // Exit pricing edit mode
  };

  if (isPending || serviceUpdatePending) {
    return <h2>Loading Service Details...</h2>;
  }

  if (isError) {
    return (
      <h2>
        Error:{" "}
        {error?.message || "Failed to fetch service data. Please try again."}
      </h2>
    );
  }

  if (!service) {
    return <h2>Error: Service not found!</h2>;
  }

  return (
    <div className={styles.detailsContainer}>
      {!isEditing ? (
        <>
          <div className={styles.titleContainer}>
            <h2 className={styles.equipmentTitle}>{service.title}</h2>
            <div className={styles.menuContainer}>
              <IoMdMore
                className={styles.moreIcon}
                onClick={() => setShowMenu(!showMenu)}
              />
              {showMenu && (
                <div className={styles.menuDropdown}>
                  <div className={styles.menuItem} onClick={handleEdit}>
                    Edit
                  </div>
                  <div
                    className={styles.menuItem}
                    onClick={() => {
                      setShowDeleteModal(true);
                      setShowMenu(false);
                    }}
                  >
                    Delete
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className={styles.infoSection}>
            <div className={styles.innerInfoSection}>
              <span
                className={`${styles.infoSectionSpan} ${
                  service.verification_status === "verified"
                    ? styles.verified
                    : service.verification_status === "pending"
                    ? styles.pending
                    : styles.rejected
                }`}
              >
                {service.verification_status === "pending"
                  ? "Requested to verify"
                  : service.verification_status === "verified"
                  ? "Verified"
                  : "Rejected"}
              </span>

              <div
                className={`${styles.infoSectionDropdownBtn} ${
                  isExpanded ? styles.expanded : ""
                }`}
                onClick={() => setIsExpanded(!isExpanded)}
              >
                {isExpanded ? (
                  <IoIosArrowUp color="white" />
                ) : (
                  <IoIosArrowDown color="white" />
                )}
              </div>
            </div>

            <div
              className={`${styles.infoContent} ${
                isExpanded ? styles.showContent : ""
              }`}
            >
              {service.verification_notes == null
                ? "Wait for Admin to verify your service."
                : service.verification_notes}
            </div>
          </div>

          <div className={styles.imageCard}>
            <img
              src={service.media?.[0]?.media_url || "/default-image.jpg"}
              alt={service.title}
              className={styles.equipmentImage}
            />
            <span
              className={`${styles.verificationStatus} ${
                service.verification_status === "verified"
                  ? styles.verified
                  : service.verification_status === "pending"
                  ? styles.pending
                  : styles.rejected
              }`}
            >
              {service.verification_status === "pending"
                ? "Requested to verify"
                : service.verification_status === "verified"
                ? "Verified"
                : "Rejected"}
            </span>
          </div>

          <div className={styles.equipmentDetails}>
            <Detail label="Service Title" value={service.title} />
            <Detail label="Description" value={service.description} />
            {/* <Detail
              label="Category"
              value={service.sub_category?.category?.category_name}
            /> */}
            {/* <Detail
              label="Equipment Used"
              value={
                <img
                  src={service.media?.[0]?.media_url || "/default-image.jpg"}
                  alt={service.title}
                  className={styles.equipmentImage}
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                  }}
                />
              }
            /> */}
            <div style={{ display: "flex", gap:"4rem" }}>
              <span style={{ fontWeight: "bold", color: "#898989" }}>
                Equipment Used:
              </span>
              <img
                src={service.media?.[0]?.media_url || "/default-image.jpg"}
                alt={service.title}
                className={styles.equipmentImage}
                style={{
                  width: "100px",
                  height: "100px",
                  objectFit: "cover",
                }}
              />
            </div>
            <Detail
              label="Half-Day Price"
              value={
                service.packages?.find((p) => p.package_name === "half")?.price
                  ? `₹${
                      service.packages.find((p) => p.package_name === "half")
                        .price
                    }`
                  : "N/A"
              }
            />
            <Detail
              label="Full-Day Price"
              value={
                service.packages?.find((p) => p.package_name === "full")?.price
                  ? `₹${
                      service.packages.find((p) => p.package_name === "full")
                        .price
                    }`
                  : "N/A"
              }
            />
            {/* <Detail label="Location" value={service.location} /> */}
            {/* <Detail
              label="Created At"
              value={new Date(service.created_at).toLocaleDateString()}
            /> */}
          </div>
        </>
      ) : (
        <div className={styles.formContainer}>
          <form className={styles.mainFormContainer} onSubmit={handleSubmit}>
            <h2 className={styles.formHeading}>Edit Service</h2>
            <p className={styles.formDescription}>
              Update details about your service and its capabilities.
            </p>
            {errorMessage && (
              <p className={styles.errorMessage}>{errorMessage}</p>
            )}
            <div className={styles.formInputContainer}>
              <h3 className={styles.labels}>Service Name</h3>
              <input
                className={styles.formInput}
                name="title"
                type="text"
                value={formData.title}
                placeholder="Enter Service Name"
                onChange={handleInputChange}
                required
              />
              <h3 className={styles.labels}>Service Description</h3>
              <input
                className={styles.formInput}
                name="description"
                type="text"
                value={formData.description}
                placeholder="Enter Service Description"
                onChange={handleInputChange}
                required
              />
              <h3 className={styles.labels}>Location</h3>
              <input
                className={styles.formInput}
                name="location"
                type="text"
                value={formData.location}
                placeholder="Enter Location"
                onChange={handleInputChange}
              />
              <h3 className={styles.labels}>Upload Image</h3>
              <div
                className={styles.DragUploader}
                onDragOver={(e) => e.preventDefault()}
                onDrop={handleDrop}
              >
                <div
                  className={`${styles.DragUploaderImageContainer} ${
                    dragging ? styles.dragActive : ""
                  }`}
                >
                  {!formData.image && !formData.serviceMediaUrl ? (
                    <>
                      <FaCloudArrowUp className={styles.uploadIcon} />
                      <p className={styles.uploadText}>Drop images here</p>
                      <p className={styles.supportedFormats}>
                        Supported formats: PNG, JPG
                      </p>
                      <p className={styles.orText}>OR</p>
                      <h2
                        className={styles.browseText}
                        onClick={handleBrowseClick}
                      >
                        <strong>Browse Images</strong>
                      </h2>
                    </>
                  ) : (
                    <img
                      src={uploadPreview}
                      alt="Preview"
                      className={styles.imagePreview}
                    />
                  )}

                  <input
                    id="file-input"
                    type="file"
                    accept="image/png, image/jpeg"
                    className={styles.fileInput}
                    onChange={(e) => handleFileUpload(e.target.files[0])}
                    hidden
                  />
                </div>

                <div className={styles.buttonContainer}>
                  <span
                    className={styles.cancelText}
                    onClick={handleCancel}
                    style={{ display: "grid", placeItems: "center" }}
                  >
                    Cancel
                  </span>
                  <button
                    type="button"
                    className={styles.uploadButton}
                    onClick={handleUpload}
                    disabled={uploadSuccess}
                  >
                    {uploadSuccess ? "Uploaded" : "Upload"}
                  </button>
                </div>
              </div>

              <div className={styles.categorySection}>
                <div className={styles.selectContainer}>
                  <h3 className={styles.labels1}>Choose Category</h3>
                  <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                    <InputLabel id="category-select-label">Category</InputLabel>
                    <Select
                      labelId="category-select-label"
                      id="category-select"
                      value={formData.sub_category}
                      label="Category"
                      onChange={handleInputChange}
                      name="sub_category"
                      required
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {serviceCategories.map((category) => (
                        <MenuItem key={category.id} value={category.id}>
                          {category.category_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </div>

              {/* Integrate ServicePackageForm for pricing */}
              {/* <ServicePackageForm
                formData={formData}
                setFormData={setFormData}
                handleNext={handleNext}
              /> */}
            </div>

            <div className={styles.formButtonsContainer}>
              <button
                type="button"
                className={styles.cancelButton}
                onClick={() => setIsEditing(false)}
              >
                Cancel
              </button>
              <button className={styles.saveButton} type="submit">
                Save
              </button>
            </div>
          </form>
        </div>
      )}

      {showDeleteModal && (
        <DeleteBox
          deleteFunction={handleDelete}
          isSuccess={serviceDeleted}
          isError={deletionError}
          contentName={service.title}
          setShowDeleteModal={setShowDeleteModal}
        />
      )}
    </div>
  );
};

// Reusable detail item component
const Detail = ({ label, value }) => (
  <div className={styles.detailItem}>
    <strong>{label}:</strong> <span>{value ?? "N/A"}</span>
  </div>
);

export default ServiceDetails;
